import { render, staticRenderFns } from "./driver-detail.vue?vue&type=template&id=293d1dfc"
import script from "./driver-detail.vue?vue&type=script&lang=js"
export * from "./driver-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports